import { InvoiceTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1972. 請求タスクMF請求金額取り込
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/update_billing_amount_by_mf
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const updateBillingAmountByMoneyForward = (props: Props): Promise<InvoiceTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/update_billing_amount_by_mf`,
    props
  );
};

export const useUpdateBillingAmountByMoneyForward = () => {
  return useMutation({
    mutationFn: updateBillingAmountByMoneyForward,
  });
};
